module.exports = "https://assets.sonder.com/n/p/_next/static/images/ta_travelers_choice-e24e03209c64264b3542b764d850a570.png";